import { Injectable } from '@angular/core';
import {
  Actions,
  createEffect,
  ofType,
  ROOT_EFFECTS_INIT,
} from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { NativeClientService } from '@shared/services/native-client.service';
import { appConfigLoaded } from '../actions/app-config.actions';
import { isNativeClientDefined } from '../actions/session-info.actions';
import { AppConfigService } from '@xt/core/app-config';

@Injectable()
export class InitEffects {
  initAppConfig$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      map(() =>
        appConfigLoaded({
          appConfig: this.appConfigService.getConfig(),
        }),
      ),
    ),
  );

  initIsNativeClient$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ROOT_EFFECTS_INIT),
      map(() => {
        const isNativeClient = this.nativeClientService.isNative;

        return isNativeClientDefined({ isNativeClient });
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private nativeClientService: NativeClientService,
    private appConfigService: AppConfigService,
  ) {}
}
